import { useNavigation } from "@react-navigation/native";
import React, { FC, useState } from "react";
import { ScrollView, StyleSheet, Text, TextInput, View } from "react-native";
import { useSelector } from "react-redux";
import { PdButton, PdButtonLabel } from "src/components/forms/button";
import { useAppDispatch } from "src/redux";
import { kColors } from "src/kColors";
import { kFonts } from "src/kFonts";
import { kRoute } from "src/kRoute";
import { kStyleConst } from "src/kStyle";
import { sendResetPasswordEmail } from "src/redux/user/actions";
import { PdStack } from "src/components/layout";

const P01_03_ForgotPassword: FC = () => {
  const kNav = useNavigation();
  const dispatch = useAppDispatch();
  const rIsMobile = useSelector(
    (state) => state.NavigationReducer.deviceSize === "xs" || state.NavigationReducer.deviceSize === "sm",
  );
  const [sEmail, setEmail] = useState<string>("");

  const sendAuthEmail = () => {
    dispatch(sendResetPasswordEmail(sEmail));
    kNav.navigate(kRoute.P01);
  };

  return (
    <ScrollView
      contentContainerStyle={[styles.container, rIsMobile ? styles.m5 : styles.m10]}
      style={styles.bgBrandLight}
    >
      <View style={rIsMobile ? styles.wFull : styles.minWContainer}>
        <Text style={[styles.h2, styles.textAlignCenter]}>Forgot Password?</Text>
        <Text style={[styles.body, styles.textAlignCenter, styles.mb10]}>
          You will receive an email with a link to change your password.
        </Text>
        <View style={styles.mb10}>
          <Text style={[styles.h3, styles.mb1]}>Email</Text>
          <TextInput
            placeholder="User Email"
            autoCompleteType="email"
            onChangeText={setEmail}
            style={styles.inputLogin}
            placeholderTextColor={kColors.gray400}
          />
        </View>
        <PdStack layout={[1, 1]} gap={5} direction={rIsMobile ? "vertical" : "horizontal"} isReversed={rIsMobile}>
          <PdButton
            colorScheme="purple"
            onPress={() => kNav.navigate(kRoute.P01)}
            size="lg"
            variant="outline"
            isFullWidth={rIsMobile}
          >
            <PdButtonLabel>Cancel</PdButtonLabel>
          </PdButton>
          <PdButton onPress={sendAuthEmail} size="lg" isFullWidth={rIsMobile}>
            <PdButtonLabel>Send</PdButtonLabel>
          </PdButton>
        </PdStack>
      </View>
    </ScrollView>
  );
};

export const P01_03 = React.memo(P01_03_ForgotPassword);
const styles = StyleSheet.create({
  bgBrandLight: {
    backgroundColor: kColors.brandLight,
  },
  body: {
    ...kFonts.poppinsRegularLight,
    color: kColors.brand500,
    letterSpacing: 1,
    lineHeight: 25,
  },
  container: {
    alignItems: "center",
    backgroundColor: kColors.white,
    borderRadius: 4 * kStyleConst.kBorderRadius,
    flexGrow: 1,
    justifyContent: "center",
    padding: 10 * kStyleConst.kSpacing,
  },
  h2: {
    ...kFonts.ralewayLargeLight,
    color: kColors.brand500,
    letterSpacing: 1.1,
    lineHeight: 35,
  },
  h3: {
    ...kFonts.H3,
    color: kColors.darkGray,
    letterSpacing: 1.1,
    lineHeight: 30,
  },
  inputLogin: {
    borderBottomWidth: 1,
    borderColor: kColors.brandPink,
    flex: 1,
    height: 36,
    outlineColor: kColors.transparent,
    ...kFonts.poppinsRegularLight,
    letterSpacing: 1,
    lineHeight: 25,
  },
  m10: {
    margin: 10 * kStyleConst.kSpacing,
  },
  m5: {
    margin: 5 * kStyleConst.kSpacing,
  },
  mb1: {
    marginBottom: 1 * kStyleConst.kSpacing,
  },
  mb10: {
    marginBottom: 10 * kStyleConst.kSpacing,
  },
  minWContainer: {
    minWidth: 600,
  },
  textAlignCenter: {
    textAlign: "center",
  },
  wFull: {
    width: "100%",
  },
});
